mobileSize = 1000;
function buttonfeature() {
  const e = $(".featureLineupContainer");
  e.length > 0 &&
      e.each((e, t) => {
          const i = $(t).find(".featureLineup-more"),
              n = $(t).find(".featureLineup-text"),
              a = n.text();
          n.html(`<span class="featureLineup-text-content">${a}</span>`), i.appendTo(n);
          // Clone featureLineup-title and dateDisplayBar
          const title = $(t).find(".featureLineup-title").clone();
          title.appendTo(n);
      });
}
$(document).ready(function(){
  
  // Search Bar Script
  //--------------------------------------
// Set placeholder text
$('.searchBoxInput input').attr('placeholder', 'Search');
$('.searchBoxInput input').val('');

  $('#mobileSearchInput').attr('placeholder', 'Search');
  $('#mobileSearchInput').val('');

  // Check Window Size
  buttonfeature();
  // General Message
  $('.generalmessage').prependTo('header');
  $('.ticket').clone().insertAfter('.nav > ul > li:nth-child(3)');
  // Check Window Size
  const windowSize = $(window).width();
  if (windowSize < 1000) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1001) {
    $('body').removeClass('saffireMobileSize');
  }
});
 
$(window).load(function(){
  $('body').addClass('pageIsLoaded'); 
   
});

$(window).resize(function(){
  
});